
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserLearningItemCollectionItems"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserLearningItemCollection"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"learningItemCollectionId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAssignment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAdopted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userCollectionStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"certificate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expired_on"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"group_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalAllocatedTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coverUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bannerUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bannerSideBarUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originalCoverUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"learningItemCollectionId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"collectionInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coverUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bannerUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bannerSideBarUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originalCoverUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalAllocatedTime"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"userInfo"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveLearningItemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastActiveStructureId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalEarnedTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalAllocatedTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reflections"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reactions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"assessments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completedAssessments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":844}};
    doc.loc.source = {"body":"fragment UserLearningItemCollectionItems on UserLearningItemCollection {\n  _id\n  userId\n  learningItemCollectionId\n  isAssignment\n  isAdopted\n  type\n  userCollectionStatus\n  certificate {\n    id\n    expired_on\n    url\n    email\n    group_id\n    type\n    totalAllocatedTime\n    coverUrl\n    bannerUrl\n    bannerSideBarUrl\n    originalCoverUrl\n    userId\n    learningItemCollectionId\n    collectionInfo {\n      id\n      title\n      description\n      type\n      coverUrl\n      bannerUrl\n      bannerSideBarUrl\n      originalCoverUrl\n      logo\n      totalAllocatedTime\n    }\n    userInfo\n  }\n  lastActiveLearningItemId\n  lastActiveStructureId\n  totalEarnedTime\n  totalAllocatedTime\n  rating\n  reflections {\n    _id\n    reactions\n    comment\n    rating\n    createdAt\n    updatedAt\n  }\n  assessments\n  completedAssessments\n  createdAt\n  updatedAt\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["UserLearningItemCollectionItems"] = oneQuery(doc, "UserLearningItemCollectionItems");
        
